export const useFormModeToggler = {
  data() {
    return {
      isEditMode: false,
      isLoadingNow: false,
      entityName: {
        readonly: 'Плата',
        modify: 'платы',
      },
    };
  },
  computed: {
    inputsWereEnabled() {
      const isAddOperation = this.$route.params.id === 'new';
      return !!(this.isEditMode || isAddOperation);
    },
    subtitle() {
      if (!this.isEditMode && this.lastSlug !== 'new') {
        return `${this.entityName.readonly} #${this.lastSlug}`;
      }
      return this.lastSlug !== 'new'
        ? `Редактирование ${this.entityName.modify} #${this.lastSlug}`
        : `Добавление ${this.entityName.modify}`;
    },
    lastSlug() {
      return this.$route.params.id;
    }
  },
  methods: {
    setEditMode(flag = true) {
      if (!flag) {
        this.$router.go()
      }
      this.isLoadingNow = true;
      setTimeout(() => {
        this.isEditMode = flag;
        this.isLoadingNow = false;
      }, 500);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/useFormModeToggler.js